export function isRetina() {
	return ('devicePixelRatio' in window && window.devicePixelRatio > 1);
}

// определить, является ли устройство мобильным
export function isMobile(): boolean {
	return !!navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|IEMobile|Opera Mini/i);
}

// определить, открыт ли сайт в приложении
export function isApp() {
	return (navigator.userAgent.indexOf('Topvisor_App') != -1);
}

// определить, является ли OS пользователя macOS
export function isMacOS() {
	return navigator.userAgent.indexOf('Mac OS X') !== -1;
}

// определить, является ли текущий браузер пользователя Safari
export function isSafari() {
	const isChrome = /Chrome|Android/.test(navigator.userAgent);

	let isSafari = /Safari/.test(navigator.userAgent);
	if (isChrome && isSafari) {
		isSafari = false;
	}

	return isSafari;
};

/**
 * Вернуть текст для обозначения клавиши Ctrl / Command в зависимости от OS
 * @returns {'Ctrl'|'⌘'}
 */
export function getCommandKeyLabel(): 'Ctrl' | '⌘' {
	if (isMacOS()) {
		return '⌘';
	} else {
		return 'Ctrl';
	}
}